import React, { PureComponent } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, DialogContainer, SelectField,TablePagination } from 'react-md';
import DataTable, { createTheme } from 'react-data-table-component';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import Error from '../component/ErrorDispaly.js';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import styles from '../css/styles.css.js';
import { AppSetting, AppProperties, IsEmailValid } from '../common/function';
import editIcon from '../images/png/edit.png';
import crossIcon from '../images/png/crossIcon.png';
import { confirmAlert } from 'react-confirm-alert';
import StudentModal from './dialogs/StudentModal.js';
import SFCustomTable from '../component/custom/SFCustomTable.js';
import { IconButton } from '@mui/material';


let selectedUserId = [];
export default class CourseStudentEnrollmentList extends PureComponent{
    AppSetting = AppSetting();
    appProperties = AppProperties();
    constructor(props){
        super(props);
        this.state={
            visible: false,
          studentEnrollmentList:[],
            slicedstudentEnrollmentList:[],
            course_id: this.props.location.query.course_id,
            course_name: this.props.location.query.course_name,
            semester_id: this.props.location.query.semester_id,
            semester_name: this.props.location.query.semester_name,
            is_current_semester: this.props.location.query.is_current_semester === "true",
            errorMessage: '',
            errorType: '',
            selectedStudents: selectedUserId,
            subsections: [],
            selectedSubSectionID: undefined,
            loading:false,
            isCheckBoxEnable: false,
            showStudentDialog: false,
            user: {},
            sections: [],
            studentFields: [
                {
                  id:'first_name',
                  name:'First Name',
                  type:'text',
                  isRequired: true,
                },
                {
                  id:'last_name',
                  name:'Last Name',
                  type:'text',
                  isRequired: true,
                },
                {
                  id:'email_id',
                  name:'Email',
                  type:'text',
                  isRequired: true,
                  validate: (txt) => {
                    let val = IsEmailValid(txt);
                    return val;
                  }
                },
                {
                  id:'section_id',
                  name:'Section',
                  type:'select',
                  isRequired: true,
                  defaultValue: parseInt(this.props.location.query.section_id, 10),
                  disabled: true,
                  items: [
                    {
                      label: this.props.location.query.section_name,
                      value: parseInt(this.props.location.query.section_id, 10)
                    }
                  ]
                }
              ]
        }
    }

    componentDidMount() {
      this.getCourseSections();
    }

    getCourseSections = () => {
      this.setState({loading: true})
      ApiRequestService({
        method: 'post',
        url: '/getAllSections',
        data: {
          course_id: parseInt(this.state.course_id, 10)
        }
      }).then(res => {
        if (res.data.data.section_names != null) {
          let sections = res.data.data.section_names;
          // sections = sections.filter(sec => sec.enable_subsection === false)
          this.setState({
            sections: sections
          });
          let updatedStudentFields = [...this.state.studentFields]
          let lastIndex = updatedStudentFields.length-1;
          let sectionDropdowns = sections.map(sec => {
            return {
              label: sec.section_name,
              value: sec.section_id
            }
          })
          updatedStudentFields[lastIndex].items = sectionDropdowns;
          this.setState({
            studentFields: updatedStudentFields
          })
        }
      }).finally(() => {
        this.setState({loading: false})
      });
    }

    addBreadCrumbs = () => {
      console.debug('Sections AddBreadCrumbs');
      this.props.replaceBreadCrumb([
        {
          name:(this.appProperties.schoolMode?'All Standards':'All Courses') ,
          type: '',
          onclickPath: 'Courses'
        },
        {
          name: this.state.course_name,
          type: (this.appProperties.schoolMode?'Standards':'Courses'),
          onclickPath:
            'sections?course_id=' +
            this.state.course_id +
            '&course_name=' +
            this.state.course_name
        }
      ]);
    };
  
    componentWillUpdate() {
      this.addBreadCrumbs();
    }
  
    componentWillMount() {
      var cour_id = parseInt(this.state.course_id, 10); 
      const payload = {
        course_id:cour_id,
        section_id:0,
        subsection_id:0,
      };
      console.log('Course id : ', payload);
      this.setState({
        loading:true
      });
      ApiRequestService({
        method: 'post',
        url: '/getAllStudentEnrollmentByID',
        data: payload
      }).then(res => {
        this.setState({
          loading:false
        });
        if (res.data.data != null) {

          let studentList = res.data.data
          let studentdata = studentList.slice(0,20)
          this.setState({
              studentEnrollmentList: res.data.data,
              slicedstudentEnrollmentList: studentdata
            });

          }else {
          this.setState({
            studentEnrollmentList: [],
            slicedstudentEnrollmentList:[]
          });
          
          }
      });

    };
  
    componentWillUnmount() {
      this.removeBreadCrumbs();
    }
  
    removeBreadCrumbs = () => {
        this.props.replaceBreadCrumb([
        ]);     
    };
    handlePagination = (start, rowsPerPage) => {
      let studentListData = this.state.studentEnrollmentList
      this.setState({
        slicedstudentEnrollmentList: studentListData.slice(start, start + rowsPerPage)
      });
    };

    handleEditStudent = (data) => {
      let fieldSubsectionIndex = this.state.studentFields.findIndex(field => field.id === "subsection_id");
      let newFields = [...this.state.studentFields];
      if (fieldSubsectionIndex > -1) {
        newFields.splice(fieldSubsectionIndex, 1);
      }
      console.debug("newFields", newFields, fieldSubsectionIndex, data);
      this.setState({
        showStudentDialog: true,
        user: data,
        studentFields: newFields
      })
    }

    deleteMapping = (id, course_id, section_id, userId) => {
      let payload = {
        course_id: course_id,
        section_id: section_id,
        userId: userId
      }
           
      ApiRequestService({
        method: 'post',
        url: '/deleteStudentSectionEnrollment',
        data: payload
      }).then(res => {
        if (res.data.message !== null && res.data.message !== "") {
          NotificationManager.error(res.data.message, "Error");
        } else {
          let updatedStudentEnrollmentList = [...this.state.studentEnrollmentList];
          let index = updatedStudentEnrollmentList.findIndex(ele => ele.id === id);
          if (index > -1) {
            updatedStudentEnrollmentList.splice(index, 1)
          }
          this.setState({
            studentEnrollmentList: updatedStudentEnrollmentList,
            slicedstudentEnrollmentList: updatedStudentEnrollmentList.slice(0, 20)
          })
        }
      })
    }

    deleteStudentSectionEnrollment = (data) => {
      console.debug("data", data)

      confirmAlert({
        title: `Do you really want to delete "${data.userid}" section enrollment?`,
        message: 'Press "Yes" to submit',
        cancelLabel: 'Yes',
        confirmLabel: 'Cancel',
        onCancel: () => this.deleteMapping(data.id, data.course_id, data.section_id, data.userid)
        
      })
    }

    getSectionNameByID(sectionID) {
      console.debug("sectionID", sectionID)
      const section = this.state.sections.find(obj => obj.section_id == sectionID);
      if (section) {
        return section.section_name;
      }
      return "";
    }

    areAllPropertiesEmptyString (obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== '') {
          return false; // Found a non-empty string property
        }
      }
      return true; // All properties have an empty string value
    }

    handleStudentDialogChange = () =>{
      console.debug("handleStudentDialogChange")
      this.setState({
        showStudentDialog: !this.state.showStudentDialog,
      })
    }

    handleError = (message) => { 
      this.setState({
        loading: false,
        errorType: 'error',
        errorMessage: message,
      })
    }

    handleLoading = (loadingFlag) => { 
      this.setState({
        loading: loadingFlag,
      })
    }

    onAddStudentComplete = (data) => {
      console.debug("data", data)
      if (data) {
        let newStudentEnrollmentList = [...this.state.slicedstudentEnrollmentList];
          let index = newStudentEnrollmentList.findIndex(student => student.userid === data.userid)
          if (index > -1) {
            newStudentEnrollmentList = [
              ...newStudentEnrollmentList.slice(0, index),
              data,
              ...newStudentEnrollmentList.slice(index + 1)
            ]
          }
          console.debug("newStudentEnrollmentList", newStudentEnrollmentList)
           this.setState({
            showStudentDialog: false,
            slicedstudentEnrollmentList: newStudentEnrollmentList,
            loading: false
          });
        } else {
          this.setState({
            loading: false
          });
        }
    }

      onUpdateStudentComplete = (data) => {
        console.debug("update student", data)
        if (data) {
          let allStudents = [...this.state.studentEnrollmentList];
          let index = allStudents.findIndex(u => u.userid === data.userid);
          if (index > -1) {
            allStudents[index] = {
              ...allStudents[index],
              ...data
          };
          let updatedSection = this.state.sections.find(sec => sec.section_id === data.section_id);
          if (updatedSection) {
            if (index > -1) {
              allStudents[index].section_name = updatedSection?.section_name
            }
          }
          }
          let slicedStudents = allStudents.slice(0, 20);
          this.setState({
            studentEnrollmentList: allStudents,
            slicedstudentEnrollmentList: slicedStudents,
            showStudentDialog: false,
          })
          NotificationManager.success('Updated the student successfully', 'Success', 3000);
        }
      }

    render(){
    const { subsections,selectedSubSectionID, isCheckBoxEnable} = this.state;
    const columns = [
      {
        name: 'Username',
        selector: 'userid',
        sortable: true,
      },
      {
        name: 'First Name',
        selector: 'first_name',
        sortable: true,
      },
      {
        name: 'Last Name',
        selector: 'last_name',
        sortable: true,
      },
      /* {
        name: 'OSU ID',
        selector: 'osu_id',
        sortable: true,
      }, */
      {
        name: 'Section',
        selector: 'section_name',
        sortable: true,
      },
      {
        name: 'Sub Section',
        selector: 'subsection_name',
        sortable: true,
      },
      {
        name: 'Actions',
        sortable: true,
        cell: (data) => {
          return <div>
            <IconButton disabled={this.state.is_current_semester === false} onClick={() => this.handleEditStudent(data)}>
                <img 
                  style={{
                    opacity: this.state.is_current_semester ? 1 : 0.5
                  }}
                src={editIcon} alt="Edit"  />
            </IconButton>
            <IconButton 
            disabled={this.state.is_current_semester === false}
            onClick={() => { this.deleteStudentSectionEnrollment(data) }}
                style={{
                  display: this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX.includes("osu") ? 'none' : 'inline-flex'
                }}
              >
                <img src={crossIcon} style={{
                  opacity: this.state.is_current_semester ? 1 : 0.5
                }} alt="Remove"  />
            </IconButton>

            {/* <Button icon tooltipLabel="Edit" onClick={() => {
                  this.handleEditStudent(data)
                }}>
                <img src={editIcon} alt="Edit"  />
            </Button>
            <Button style={{
              display: this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX.includes("osu") ? 'none' : 'inline-block'
            }} icon tooltipLabel="Remove" onClick={() => {
                this.deleteStudentSectionEnrollment(data)
              }}>
                <img src={crossIcon} alt="Remove"  />
            </Button> */}
          </div>
        }
      },
    ];

    const customStyles = {
      headCells: {
        style: {
          fontSize: '14px', 
          fontWeight: 'bold',
        },
      }, 
    };

    let button =(
        <Button   style={ styles.addButton} onClick={this.BulkUpdate} disabled={selectedSubSectionID ? false : true}>
          Move Student(s)
        </Button>
      );
    var cancelButton = (
      <Button style={styles.cancelButton} onClick={this.hide}>
        Cancel
      </Button>
    );

    const actions = [];
    actions.push(button);
    actions.push(cancelButton);
        return (
            (this.state.loading)?
               <LoadingSpinner loading={this.state.loading} />
            :
            <SecureShow targetRole={1}>
              <div>
                {/* <div onClick = {this.subjPage} style={subjPage}>Courses >  </div>
                  <div onClick = {this.sectionPage} style={sectionPage}>Sections</div> */}
      
                <div style={styles.sectionTitle}>
                  Students under - {this.state.course_name}  ({this.state.studentEnrollmentList.length})
                  {(parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10)) >= 1 ? (
                  <div style={styles.floatRight}>
                  </div>
                ) : (
                      ''
              )}
                </div>
      
                
                  <SFCustomTable 
                    showSearch={true}
                    columns={columns}
                    selectableRows={false}
                    onSelectedRowsChange={() => {}}
                    data={this.state.studentEnrollmentList}
                    selectedData={null}
                    topPagination={true}
                    bottomPagination={true}
                    defaultRowsPerPage={20}
                    onPagination={this.handlePagination}
                    searchPlaceholder={"Search by name"}
                    searchByFields={["userid", "first_name", "last_name"]}
                  />

                   <StudentModal 
                    showDialog={this.state.showStudentDialog}
                    fields={this.state.studentFields}
                    data={this.state.user}
                    handleHide={() => this.setState({showStudentDialog:false})}
                    onAddStudentComplete={this.onAddStudentComplete}
                    onUpdateStudentComplete={this.onUpdateStudentComplete}
                    courseID={parseInt(this.state.course_id)}
                    course_name={this.state.course_name}
                  />

               
                <Error
                  type={this.state.errorType}
                  message={this.state.errorMessage}
                />
              </div>
            </SecureShow>
          );
    }
} 